<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectWorkOrder"
        :value="value"
        :label="label"
        :options="activeWorkOrders"
        :reduce="workOrder => workOrder.id"
        :getOptionLabel="workOrder => workOrder.name"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import { mapState } from 'vuex';
import WorkOrderCreateModal from '@/components/modals/WorkOrderCreateModal';

export default {
    name: 'FormSelectWorkOrder',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Work Order' },
        showCreateOption: { type: Boolean, default: false },
    },

    data: () => ({
        initialValue: null,
    }),

    computed: {
        ...mapState('company', ['workOrders']),

        activeWorkOrders() {
            return this.workOrders.filter((workOrder) => {
                return workOrder.id === this.initialValue ? true : workOrder.isActive;
            });
        },
    },

    beforeMount() {
        this.initialValue = this.value;
    },

    methods: {
        handleInput(workOrderId) {
            this.$emit('input', workOrderId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_work_order', {
                model_type: 'workOrder',
                model_action: 'create_intent',
            });

            this.$modal.show(WorkOrderCreateModal, {
                onWorkOrderCreated: this.handleWorkOrderCreated
            });
        },

        handleWorkOrderCreated(newWorkOrder) {
            this.$emit('input', newWorkOrder.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectWorkOrder {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>
